import { useLingui } from "@lingui/react/macro"
import { useNow } from "@/hooks/use-now"

// Formats elapsed seconds as m:ss (or h:mm:ss past an
// hour). Exported for unit testing the boundaries.
export function formatDuration(totalSeconds: number): string {
  const safe = Math.max(0, Math.floor(totalSeconds))
  const hours = Math.floor(safe / 3600)
  const minutes = Math.floor((safe % 3600) / 60)
  const seconds = safe % 60
  const pad = (n: number) => n.toString().padStart(2, "0")

  if (hours > 0) {
    return `${hours}:${pad(minutes)}:${pad(seconds)}`
  }
  return `${minutes}:${pad(seconds)}`
}

interface CallDurationProps {
  // ms-epoch when the call connected, or null while ringing.
  connectedAt: number | null
  className?: string
}

// Live in-call timer. Ticks every second off `useNow` so it
// advances without any other prop change. Shows a steady
// placeholder until the call connects.
export function CallDuration({
  connectedAt,
  className = "",
}: CallDurationProps) {
  const { t } = useLingui()
  const now = useNow(1_000)

  const label =
    connectedAt === null
      ? t`Connecting…`
      : formatDuration((now.getTime() - connectedAt) / 1000)

  return (
    <span className={className} aria-live="polite">
      {label}
    </span>
  )
}
